export const GUEST_TOKEN = 'guestToken';
export const USER_TOKEN = 'token';
export const EXPIRES_IN = 'EXPIRES_IN';
export const REFRESH_TOKEN = 'refreshToken';
export const TYPE_OF_LOGIN = 'login';
export const SETTINGS = 'settings';
export const RECENT_SEARCHES = 'Recent Searches';
export const SELECTED_PLAN = 'selectedPlan';
export const USER_CONSENTS = 'userConsents';
export const USER_ID = 'ID';
export const USER_TYPE = 'userType';
export const SOCIAL_LOGIN_TYPE = 'typeOfSocialLogin';
export const COUNT_REACHING_PAGE = 'countReachingPage';
export const SESSION_ID = 'sessionID';
export const SUBSCRIPTION_PREVIOUS_ROUTE = 'subscriptionPreviousRoute';
export const REDIRECT_AFTER_TWITTER_LOGIN = 'redirectAfterTwitterLogin';
export const ACCOUNT_INFO_TWITTER_LOGIN = 'accountInfoTwitterLogin';
export const PAYMENT_OBJECT = 'paymentObject';
export const IS_NEW_USER = 'isNewUser';
export const WATCHLIST_ITEM = 'watchlistItem';
export const IS_TELCO_USER = 'isTelcoUser';
export const SKIP_CONTENT_LANGUAGES_POPUP = 'skipContentLanguagesPopup';
export const PAYMENT_PROVIDER = 'paymentProvider';
export const VERIFY_CODE_MESSAGE = 'verifycodemessage';
export const DEFAULT_A2HS_CALLED = 'defaulta2hscalled';
export const TRIGGERING_SAVE_SETTINGS = 'triggeringSaveSettings';
export const RSVOD_PACK = 'RSVODpack';
export const MANDATORY_REGISTRATION_POPUP_COUNT =
  'mandatoryRegistrationPopupCount';
export const MANDATORY_REGISTRATION_VIDEO_COUNT =
  'mandatoryRegistrationVideoCount';
export const PARTNER_NAME = 'partnerName';
export const SKIP_MANDATORY_REG_POPUP = 'skipManRegpop';
export const NOT_NOW_A2HS_BM = 'notNowA2hsBm'; // Session storage
export const NOT_NOW_A2HS_LOGIN_REG = 'notNowA2hLoginReg'; // Session storage
export const IS_WIDGET_OPEN_A2HS = 'isWidgetOpenA2hs';
export const NOT_NOW_A2HS_PS = 'notNowA2hsPs'; // Session storage
export const NOT_NOW_A2HS_LANDING = 'notNowA2hLanding'; // Session storage for landing page
export const TV_AUTENTICATION_QUERY = 'tvAutenticationQuery'; // session storage
export const TV_AUTHENTICATION_SOCIAL_PARAMETER =
  'tvAuthenticationSocialParameter';
export const ONBOARDING_JOURNEY_POPUP = 'onboardingJourneyPopup';
export const NUTS_VALUE = 'nutsValue';
export const FIRST_PAGE_NAME = 'firstPageName'; // session storage
export const MIXPANEL_SILENT_LOGIN = 'mixpanelSilentLogin';
export const EDUAURAA = 'eduauraa';
export const WATCHHISTORY_STORE = 'adoric_watch_history';
export const UTM_CAMPAIGN = 'UTM_CAMPAIGN';
export const LATEST_EPISODE_OF_LAST_WATCHED_SHOW =
  'adoric_latest_episode_of_last_watched_show';
export const ADORIC_WATCH_DURATION_TOTAL = 'adoric_watch_duration_total';
export const ADORIC_WATCH_DURATION_SINCE = 'adoric_watch_duration_since';
export const IS_COUNTRY_CHANGE = 'isCountryChange';
export const COUNTRYCHANGE = 'countryChange';
export const LOGIN_VIA_ACCOUNT_INFO = 'loginViaAccountInfo';
export const LOGIN_VIA_ACCOUNT_INFO_RELOAD = 'loginViaAccountInfoReload';
// for setting one trust
export const GDPRAPPIES = 'gdpr_applies';
export const ONETRUSTACTIVEGROUPS = 'onetrust_group';
export const TCSTRING = 'tc_string';
export const NOT_NOW_APP_DOWNLOAD = 'notNowAppDownload';
export const RENEWAL_CANCEL_EVENT_TIME =
  'adoric_auto_renewal_cancel_event_time';
export const ADORIC_WATCHLIST_DATA = 'adoric_watchlist_data';
export const ENTITLEMENT_USER_TYPE = 'entitlementUserType';
export const IS_PREVIEW = 'isPreview';
export const IS_UPGRADE = 'isUpgrade';
export const WAIVER_AMT = 'waiverAmount';
export const QG_ATTRIBUTES_TRIGGER = 'qgAttributesTrigger';
export const USER_LOGGEDIN = 'userLoggedIn';
export const REGISTEREDFIRST = 'registeredfirst';
export const IS_USER_LOGGEDIN = 'isUserLoggedIn';
export const USER_REDIRECTED_TO_PARTNER = 'userRedirectedToPartner';
export const TVOD_JUST_BOUGHT = 'tvodJustBought';
export const UTM_SOURCE = 'utmSource'; // session storage
export const KALTURA_MUTED_VALUE = 'kaltura-player-js_muted';
export const LANGUAGECHANGE = 'languageChange';
export const IGNORE_SUPPORT_POPUP = 'ignoreSupportPopup';
export const PACK_TOGGLE_COUNTER = 'packToggleCounter'; // session storage
export const UPGRADE_NUDGE = 'upgradeNudge';
export const ADVANCE_RENEWAL_NUDGE = 'advanceRenewalNudge';
export const ADVANCE_RENEWAL_ACTION = 'AdvanceRenewal';
export const FILTERED_PLAN = 'filteredPlan';
export const SUBSCRIBE_FROM_PLAYER = 'subscribeFromPlayer';
export const NETWORK_ERROR = 'networkError';
export const PAYMENT_ISSUER = 'paymentIssuer';
export const ISSUBSCRIPTION = 'isSubscrption';
export const COMBO_PAGE = 'isFromComboPack';
export const ISSUBSCRIPTIONEXPIRED = 'issubscriptionExpired';
export const CTMADATA = 'ctma';
export const CTMA_IS_REGISTER = 'CTMA_FROM_REGISTER';
export const CTMA_ID = 'ctma_id';
export const AKAMAIEDGE = 'AKAMAIEDGE';
export const REGION = 'REGION';
export const API_PROVIDERS = 'API_PROVIDERS';
export const TAPP_OBJECT = 'tappObject';
export const BACK_TO_APPWIDGET = 'backToAppWidget'; // session storage
export const VIBLOCKERFLAG = 'viBlockerFlag'; // session storage
export const GLOBAL_REGION = 'GLOBAL_REGION';
export const CTMA_IS_LOGIN = 'CTMA_FROM_LOGIN';
export const PARTNER_SOURCE = 'partner_source'; // session storage
export const IS_LAPSER_NUDGE_CANCELLED = 'isLapserNudgeCancelled'; // session storage
export const IS_ADVANCE_RENEWAL_NUDGE_CANCELLED =
  'isAdvnceRenewalNudgeCancelled'; // session storage
export const OFFER_PATH = 'offerPath';
export const IS_EDUAURAA_BUYPLAN = 'isEduauraaBuyPlan'; // session storage
export const EDUAURAA_SUBSCRIPTION = 'Eduauraa_Subscription'; // session storage
export const REQUEST_ID = 'REQUEST_ID'; // Global ID for Telco
export const ZIPCODE = 'zipCode';
export const MANDATORY_USER_DETAILS = 'mandatoryUserDetails';
export const USREFERRAL_FLAG = 'USReferral';
export const USREFERRAL_OBJ = 'usReferralObj';
export const VOUCHER_DATA = 'voucher_data';
export const SHD_CALL_OBJECT = 'SHD_CALL_OBJECT';
// new payment journey from consumption page
export const IS_CONSUMPTION_PAYMENT_JOURNEY = 'IsConsumptionPaymentJourney';
export const CONSUMPTION_PAYMENT_JOURNEY_PATH = 'ConsumptionPaymentJourneyPath';
export const CONSUMPTION_PAYMENT_SUCCESS = 'ConsumptionPaymentSuccess';
export const ONBOARDING_JOURNEY = 'ONBOARDING_JOURNEY';
export const DATA_COLLECTION_CONST = 'DATA_COLLECTION';
export const CARD_CLICK_COUNT = 'card_click_count';
export const DATA_ERROR = 'data_collection_error';
export const GUEST_USER_REG_OBJ = 'GUEST_USER_REG';
export const CONSUMPTION_JOURNEY_CODE_REDEMPTION_OBJ =
  'CONSUMPTION_JOURNEY_CODE_REDEMPTION_OBJ';
export const GUEST_USER_PAYMENT_DETAILS = 'guestUserPaymentDetails';
export const SUBSCRIPTION_PAYMENT_NOT_LINKED = 'subscriptionPaymentNotLinked';
export const SUBSCRIPTION_ORDER_SUMMARY_BANNER =
  'subscriptionOrderSummaryBanner';
export const USER_SKIPPED_MOBILE_ADD = 'USER_SKIPPED_MOBILE_ADD';
export const LR_PIN_FLOW = 'livingRoomPinFlow';
export const SEARCH_PARENTAL_WIDGET = 'searchParentalWidget';
export const SEARCH_PARENTAL_WIDGET_COUNT = 'searchParentalWidgetCount';
export const IS_ACTIVE_SUBSCRIPTION_FOUND = 'isActiveSubscriptionFound';
export const SELECTED_VARIANT = 'SELECTED_VARIANT';
export const EXPERIMENT_NAME = 'EXPERIMENT_NAME'; // session storage
export const LOGIN_RESULT = 'LOGIN_RESULT';
export const IS_PREPAID_COUPON_LOGIN = 'IS_PREPAID_COUPON_LOGIN';
export const REDIRECT_URL_FROM_SUBSCRIPTION = 'REDIRECT_URL_FROM_SUBSCRIPTION';
export const REDIRECT_URL_TO_CONSUMPTION = 'REDIRECT_URL_TO_CONSUMPTION';
export const PREVIOUS_CONSUMPTION_PAGE_LANGUAGES =
  'previousConsumptionPageLanguage';
export const NEW_NFT_MENU_ITEM_FLAG = 'newNftMenuItemAdded';
export const ACTUAL_PRICE = `actual_price`;
export const REFERRAL_ID = 'referralId';
export const REFERRAL_NAME = 'referralName';
export const REFERRAL_CODE = 'referralCode';
export const REFERRAL_USERID = 'referralUserId';
export const VISITED_PAYMENT_PAGE = 'visitedPaymentPage';
export const TAPPP_ERROR_FLAG = 'TAPPP_ERROR_FLAG';
export const PARTNER_PLAN_DETAILS = 'partnerPlanDetails';
export const GUEST_WATCH_HISTORY = 'WatchHistoryLS';
export const ACTIVE_PARTNER_SUBSCRIPTIONS = 'activePartnerSubscriptions';
export const CONSUMPTION_LANGUAGE_FROM_PWA = 'consumptionLanguageFromPWA';
export const CONSUMPTION_LANGUAGE_FROM_WEBAPP = 'consumptionLanguageFromWebapp';
export const IS_RENEWAL_PLAN_SAME_AS_EXPIRED_FOR_LAPSER =
  'isRenewalPlanSameAsExpiredForLapser';
export const QWIKCILVER_TYPE = 'qwikcilverType';
export const API_IDENTIFICATION_CODE = 'apiIdentificationCode';
export const API_ERROR_MESSAGE = 'apiErrorMessage';
export const USER_MOB = 'USER_MOB';
export const USER_MAIL = 'USER_MAIL';
export const COMMERCE_WISHLISTED_PRODUCTS = 'commerceWishlistedProducts';
export const OPEN_PURCHASE_POPUP = 'openPurchasePopup';
export const SEARCH_LANDING_DATA = 'searchLandingData';
export const STUDENT_VERIFICATION_ID = 'student_verification_id';
export const PAYMENT_JOURNEY = 'payment_journey';
export const RSJ_SUBSCRIPTION_PAYMENT_NOT_LINKED =
  'rsjSubscriptionPaymentNotLinked';
export const WATCH_LIST_SESSION_STORAGE_OBJECT = 'watchListObject';
export const PAYMENT_JOURNEY_SOURCE = 'payment_journey_source';
